import styled from 'styled-components';
export const LabelWrapper = styled.div `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const Tag = styled.div `
  ${({ theme }) => theme.typography.textMedium};
  display: grid;
  place-items: center;
  padding: 2px 6px;
  background: ${({ theme }) => theme.colors.grey10_1};
  border-radius: 8px;
`;
export const Value = styled.span `
  &&& {
    color: ${({ theme }) => theme.colors.black_1};
    ${({ theme }) => theme.typography.weightMedium}
  }
`;
